module.exports = __webpack_public_path__ + "assets/img/img250.ca58a0e5.png";